module.exports = __webpack_public_path__ + "static/media/sjzlLogo.44035029.png";